<template>
<div class="manager_dashboard">
<user-menu />
<div class="wrapper">
  <masteradmin-sidebar-menu v-if="((masterAdmin === true) && (!$store.state.switch_admin_username))" />
  <admin-sidebar-menu v-if="((admin === true))" />
  <div class="content-wrapper">
<div class="container-wrapper center">
<div>
  <GoBack v-if="showBackButton" />
  <h3 class="d-inline heading">{{ pageName }}</h3>
</div>
<div class="heading-seperator"></div>
<div class="content-main-wrapper center" v-if="action == 'view-profile'">
<div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
<div v-if="loading === false">
<flash-message autoHide variant="success"></flash-message>
<div class="row marginbot10 profile-heading">
  <div class="col-md-9 col-sm-9 col-xs-9"><h3>Personal Details</h3></div>
  <div class="col-md-3 col-sm-3 col-xs-3" id="profile-link-wrapper"><span class="float-right">
  <a @click="setprofile_mode('edit-profile')" class="profile-link">EDIT</a></span></div>
</div>
  <div class="row marginbot10">
    <div class="col-md-4 col-sm-4 col-xs-4"><label>First Name</label></div>
    <div class="col-md-8 col-sm-8 col-xs-8">{{ first_name }}</div>
  </div>
  <div class="row marginbot10">
    <div class="col-md-4 col-sm-4 col-xs-4"><label>Last Name</label></div>
    <div class="col-md-8 col-sm-8 col-xs-8">{{ last_name }}</div>
  </div>
  <div class="row marginbot10">
    <div class="col-md-4 col-sm-4 col-xs-4"><label>Email</label></div>
    <div class="col-md-8 col-sm-8 col-xs-8">{{ email }}</div>
  </div>
  <div class="row marginbot10">
    <div class="col-md-4 col-sm-4 col-xs-4"><label>Role</label></div>
    <div class="col-md-8 col-sm-8 col-xs-8">
      <span class="roles" v-for="(option, key, index) in roles">
        <span v-if="roles.length == (key+1)">{{ rolesFormatter(option) }}</span>
        <span v-else>{{ rolesFormatter(option) }}, </span>
      </span>
    </div>
  </div>
  <div class="row marginbot10">
    <div v-if="isMenteeUserProfile()" class="col-md-4 col-sm-4 col-xs-4"><label>Mentors</label></div>
    <div v-else class="col-md-4 col-sm-4 col-xs-4"><label>Groups</label></div>
    <div class="col-md-8 col-sm-8 col-xs-8">{{ group_names.join(', ') }}</div>
  </div>
  <div class="row marginbot10">
    <div class="col-md-4 col-sm-4 col-xs-4"><label>Phone Number</label></div>
    <div class="col-md-8 col-sm-8 col-xs-8">{{ phone_number }}</div>
  </div>
  <div v-show="isUser()">
    <div class="profile-sec-sep"></div>
    <div class="row marginbot10 profile-heading" id="profile-link-wrapper">
      <div class="col-md-9 col-sm-9 col-xs-9"><h3>Change Password</h3></div>
      <div class="col-md-3 col-sm-3 col-xs-3"><span class="float-right">
      <a @click="setprofile_mode('change-password')" class="profile-link">EDIT</a></span></div>
    </div>
    <div class="row marginbot10">
      <div class="col-md-4 col-sm-4 col-xs-4"><label>Password</label></div>
      <div class="col-md-8 col-sm-8 col-xs-8">********</div>
    </div>
  </div>

  <div v-show="isUser()">
    <div class="profile-sec-sep"></div>
    <div class="row marginbot10 profile-heading" id="profile-link-wrapper">
      <div class="col-md-9 col-sm-9 col-xs-9"><h3>My Documents</h3></div>
      <div class="col-md-3 col-sm-3 col-xs-3"><span class="float-right">
      <a @click="setprofile_mode('change-password')" class="profile-link">EDIT</a></span></div>
    </div>
    <div class="row marginbot10">
      <div class="col-md-4 col-sm-4 col-xs-4"><label>Password</label></div>
      <div class="col-md-8 col-sm-8 col-xs-8">********</div>
    </div>
  </div>

  <div v-show="isMenteeNotificationSettings()">
    <div class="profile-sec-sep"></div>
    <div class="row marginbot10 profile-heading" id="profile-link-wrapper">
      <div class="col-md-9 col-sm-9 col-xs-9"><h3>Notification Settings</h3></div>
      <div class="col-md-3 col-sm-3 col-xs-3"><span class="float-right">
      <a @click="setprofile_mode('notification-settings')" class="profile-link">EDIT</a></span></div>
    </div>
    <div class="row marginbot10">
      <div class="col-md-4 col-sm-4 col-xs-4"><label>Email</label></div>
      <div class="col-md-8 col-sm-8 col-xs-8" style="text-transform: capitalize;">{{ email_display_flag }}</div>
    </div>
    <div class="row marginbot10">
      <div class="col-md-4 col-sm-4 col-xs-4"><label>SMS</label></div>
      <div class="col-md-8 col-sm-8 col-xs-8" style="text-transform: capitalize;">{{ sms_display_flag }}</div>
    </div>
    <div class="row marginbot10">
      <div class="col-md-4 col-sm-4 col-xs-4"><label>Frequency</label></div>
      <div class="col-md-8 col-sm-8 col-xs-8" style="text-transform: capitalize;">{{ frequency_value.toLowerCase() }}</div>
    </div>
  </div>


   <div v-show="isMenteeProfile()">
     <div class="profile-sec-sep"></div>
     <div class="row marginbot10 profile-heading" id="profile-link-wrapper">
       <div class="col-md-9 col-sm-9 col-xs-9"><h3>Tasklist Assignment</h3></div>
       <div class="col-md-3 col-sm-3 col-xs-3"><span class="float-right">
       <a v-show="isMenteeTasklistEdit()" @click="setprofile_mode('tasklist-assignment')" class="profile-link">EDIT</a></span></div>
     </div>
     <div class="row marginbot10">
       <div class="col-md-12">
        <ul v-for="taskListsName in taskListsNames">
        <li>{{taskListsName}}</li>
        </ul>
       </div>
     </div>
   </div>

  </div>
</div>

  <div class="content-main-wrapper center edit-profile-wrapper" id="edit-profile-wrapper" v-else-if="action == 'edit-profile'">
  <form @submit.prevent="onUpdate">
    <div class="row margin-bottom-15">
      <div class="col-12 col-sm-12">
      <label
          for="first_name"
          class="col-12">First name : <span class="required">*</span></label>
      <input
          type="first_name"
          name="first_name"
          class="col-12 col-sm-12 input-height-35"
          ref="first_name"
          v-validate="'required'"
          v-model="first_name"
          data-vv-as="First name"
          maxlength="180">
      <div v-show="verrors.has('first_name')" class="validate-warning-msg">{{ verrors.first('first_name') }}</div>
      </div>
    </div>
    <div class="row margin-bottom-15">
      <div class="col-12 col-sm-12">
      <label
          for="last_name"
          class="col-12">Last name : <span class="required">*</span></label>
      <input
          type="last_name"
          name="last_name"
          class="col-12 col-sm-12 input-height-35"
          ref="last_name"
          v-validate="'required'"
          v-model="last_name"
          data-vv-as="Last name"
          maxlength="180">
      <div v-show="verrors.has('last_name')" class="validate-warning-msg">{{ verrors.first('last_name') }}</div>
      </div>
    </div>
    <div class="row margin-bottom-15" v-if="admin_flag === true && role_options != ''">
      <div class="col-12 col-sm-12">
        <label
            for="roles"
            class="col-12">Roles : <span class="required">*</span></label>
        <div class="col-12 col-sm-12 chkboxwrapper" v-for="(option, key, index) in role_options">
          <div v-if="index == 0">
            <input :value="key" type="checkbox"
              name="roles" v-model="roles"
              v-validate data-vv-rules="required" data-vv-as="Roles"
              :disabled="(is_mentee == 1 && ((key == 'ROLE_MENTOR') || (key == 'ROLE_INSTRUCTOR')))"
              >
            <label :for="option">{{ option }}</label>
          </div>
          <div v-else>
            <input :value="key" type="checkbox"
              name="roles" v-model="roles"
              :disabled="(is_mentee == 1 && ((key == 'ROLE_MENTOR') || (key == 'ROLE_INSTRUCTOR')))"
            >
            <label :for="option">{{ option }}</label>
          </div>
        </div>
        <div v-show="verrors.has('roles')" class="validate-warning-msg">{{ verrors.first('roles') }}</div>
      </div>
    </div>
    <div class="row margin-bottom-15" v-show="showGroupEdit">
      <div class="col-12 col-sm-12" v-if="isMenteeUserProfile()">
        <label
            for="roles"
            class="col-12">Mentors : <span class="required">*</span></label>
        <div class="col-12 col-sm-12 chkboxwrapper" v-for="(option, key, index) in groups_options">
          <div v-if="key == 0">
            <input :value="option.id" :id="option.id" type="checkbox" name="mentors" v-model="groups" v-validate data-vv-rules="required">
            <label :for="option.groupName">{{ option.groupName }}</label>
          </div>
          <div v-else>
            <input :value="option.id" :id="option.id" type="checkbox" name="mentors" v-model="groups">
            <label :for="option.groupName">{{ option.groupName }}</label>
          </div>
        </div>
        <div v-show="verrors.has('mentors')" class="validate-warning-msg">{{ verrors.first('mentors') }}</div>
      </div>
      <div class="col-12 col-sm-12" v-else>
        <label
            for="roles"
            class="col-12">Groups : <span class="required">*</span></label>
        <div class="col-12 col-sm-12 chkboxwrapper" v-for="(option, key, index) in groups_options">
          <div v-if="key == 0">
            <input :value="option.id" :id="option.id" type="checkbox" name="groups" v-model="groups" v-validate data-vv-rules="required">
            <label :for="option.groupName">{{ option.groupName }}</label>
          </div>
          <div v-else>
            <input :value="option.id" :id="option.id" type="checkbox" name="groups" v-model="groups">
            <label :for="option.groupName">{{ option.groupName }}</label>
          </div>
        </div>
        <div v-show="verrors.has('groups')" class="validate-warning-msg">{{ verrors.first('groups') }}</div>
      </div>
    </div>
    <div class="row margin-bottom-15">
      <div class="col-12 col-sm-12">
      <label
          for="phone_number"
          class="col-12">Phone Number : </label>
      <input
          type="phone_number"
          name="phone_number"
          class="col-12 col-sm-12 input-height-35"
          ref="phone_number"
          v-model="phone_number"
          data-vv-as="Phone number"
          maxlength="20"
          @keyup="phoneNumberFormat()"
          @blur="phoneNumberFormat()"
          v-validate="{ rules: { regex: phoneNumberValidRegex() } }">
      <div v-show="verrors.has('phone_number')" class="validate-warning-msg">{{ verrors.first('phone_number') }}</div>
      </div>
    </div>
    <div class="submit margin-bottom-15 float-right">
      <button type="submit" class="btn btn-info btn-md">Update Profile</button>
    </div>
    <div style="clear: both"></div>
  </form>
  </div>


  <div class="content-main-wrapper notification-wrapper center edit-profile-wrapper" id="edit-profile-wrapper" v-else-if="action == 'notification-settings'">
  <form @submit.prevent="updateMenteesNotifications">
  <div class="row margin-bottom-15">
    <div class="col-12 col-sm-12">
      <label
        for="roles"
        style="font-size: 16px;padding-bottom: 20px;"
        class="col-12">Notification Settings : </label>
        <div class="chkboxwrapper">
          <div class="col-12 col-sm-12 override-padding ">
            <div class="col-3 float-left override-padding">
              <label class="label-bold" for="">Email</label>
            </div>
            <div class="col-9 float-left override-padding">
                <label class="switch">
                  <input class="custom-control-input" value="1"
                    id="email_flag" type="checkbox"
                    name="email_flag" v-model="email_flag">
                  <span class="slider round"></span>
                </label>
            </div>
          </div>
          <div style="clear: both"></div>
          <div class="col-12 col-sm-12 override-padding">
            <div class="float-left col-3  override-padding">
              <label class="label-bold" for="">SMS</label>
            </div>
            <div class="float-left col-9 override-padding ">
              <label class="switch">
                <input class="custom-control-input" value="1"
                  type="checkbox" id="sms_flag" name="sms_flag"
                  v-model="sms_flag"
                  v-on:change="displayNotificationSetting()">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
      <div v-show="verrors.has('roles')" class="validate-warning-msg">{{ verrors.first('roles') }}</div>
    </div>
    <div class="row col-12 margin-bottom-15 override-padding" v-if="notification_phone">
      <div class="col-12 col-sm-12">
      <label
          for="phone_number"
          class="col-12">Phone Number : <span class="required">*</span></label>
      <input
          type="phone_number"
          name="phone_number"
          class="col-12 col-sm-12 input-height-35"
          ref="phone_number"
          v-validate="'required|numeric'"
          v-model="phone_number"
          data-vv-as="Phone number"
          maxlength="20">
      <div v-show="verrors.has('phone_number')" class="validate-warning-msg">{{ verrors.first('phone_number') }}</div>
      </div>
    </div>
    <div class="col-12 col-sm-12">
      <div class="col-3 float-left override-padding">
        <label class="label-bold" for="">Frequency</label>
      </div>
      <div class="col-lg-9 col-12 float-left override-padding create_tasks_status">
        <div class="col-lg-5 float-left col-12 override-padding" v-for="(option, index) in frequency_options">
          <input :value="option.value" type="radio" name="frequency_value" v-model="frequency_value">
          <label >{{ option.text }}</label>
        </div>
      </div>
    </div>
    <div style="clear: both"></div>



  </div>
  <div class="submit margin-bottom-15 float-right">
      <button type="submit" class="btn btn-info btn-md">Update</button>
  </div>
  </form>
 </div>


  <div class="content-main-wrapper center edit-profile-wrapper" id="edit-profile-wrapper" v-else-if="action == 'tasklist-assignment'">
  <form @submit.prevent="updateMenteesTasklist">
  <div class="row margin-bottom-15">
    <div class="col-12 col-sm-12">
      <label
          for="roles"
          class="col-12">Tasklists to be assigned : <span class="required">*</span></label>
          <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in editTaskLists">
            <div class="chkboxwrapper">
              <input :value="option.id" :id="option.id" type="checkbox" name="tasklist_assigned" v-model="taskListsAssigned">
              <label :for="option.name">{{ option.name }}</label>
            </div>
          </div>
      <div v-show="verrors.has('roles')" class="validate-warning-msg">{{ verrors.first('roles') }}</div>
    </div>
  </div>
  <div class="submit margin-bottom-15 float-right">
      <button type="submit" class="btn btn-info btn-md">Update</button>
  </div>
  </form>
 </div>

  <div class="content-main-wrapper center edit-profile-wrapper" id="edit-profile-wrapper" v-else>
  <form @submit.prevent="onSubmit">
<div class="row margin-bottom-15">
  <div class="col-12 col-sm-12">
  <label
      for="password"
      class="col-12">New Password : <span class="required">*</span></label>
  <input
      type="password"
      name="password"
      id="password"
      class="col-12 col-sm-12 input-height-35"
      v-validate="'required'"
      v-model="password"
      ref="password"
      data-vv-as="Password"
      maxlength="20">
  <div v-show="verrors.has('password')" class="validate-warning-msg">{{ verrors.first('password') }}</div>
  </div>
</div>
<div class="row margin-bottom-15">
  <div class="col-12 col-sm-12">
  <label
      for="confirm_password"
      class="col-12">Confirm Password : <span class="required">*</span></label>
  <input
      type="password"
      name="confirm_password"
      id="confirm_password"
      class="col-12 col-sm-12 input-height-35"
      v-validate="'required|confirmed:password'"
      v-model="confirm_password"
      ref="confirm_password"
      data-vv-as="Confirm password"
      maxlength="20">
  <div v-show="verrors.has('confirm_password')" class="validate-warning-msg">{{ verrors.first('confirm_password') }}</div>
  </div>
</div>
  <div class="submit margin-bottom-15 float-right">
      <button type="submit" class="btn btn-info btn-md">Update Password</button>
    </div>
  </form>
  </div>

</div>
</div>
</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import GoBack from './shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../router/index.js';
import { store } from '../store/store';
import UserMenu from './shared/user_menu.vue';
import MasteradminSidebarMenu from './shared/masteradmin_sidebar_menu.vue';
import {ValidationMethods} from './shared/common_validations.js';
import AdminSidebarMenu from './shared/admin_sidebar_menu.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  mixins: [ValidationMethods],
  data() {
   return {
      action: 'view-profile',
      first_name: '',
      last_name: '',
      phone_number: '',
      email: '',
      roles: [],
      role_options: [],
      groups: [],
      group_names: [],
      groups_options: [],
      update_url: '',
      get_url: '',
      password: '',
      confirm_password: '',
      admin_flag: false,
      email_flag: false,
      sms_flag: false,
      loading: false,
      taskListsAssigned: [],
      taskListsNames: [],
      editTaskLists: [],
      showGroupEdit: false,
      notification_phone: false,
      email_display_flag: 'No',
      sms_display_flag: 'No',
      frequency_options: [
        { value: 'DAILY', text: 'Daily' },
        { value: 'WEEKLY', text: 'Weekly' },
      ],
      frequency_value: 'DAILY',
      masterAdmin: false,
      admin: false,
      pageName: 'MY PROFILE',
      is_mentee: 0,
      showBackButton: false,
    }
  },
  components: {
    GoBack,
    UserMenu,
    MasteradminSidebarMenu,
    AdminSidebarMenu
  },
  methods: {
    isUser() {
      if(this.$route.params.user_id) {
          return false;
      }
      else {
          return true;
      }
    },
    isMenteeProfile() {
      if((this.roles.indexOf('ROLE_MENTEE') !='-1') || (this.roles.indexOf('ROLE_STUDENT') !='-1')) {
          return true;
      }
      else {
          return false;
      }
    },
    isMenteeTasklistEdit() {
      var loggedinUserRoles = store.state.roles;
      if(((loggedinUserRoles.indexOf('ROLE_ADMIN') != '-1') || (store.state.switch_admin_username)) && (this.roles.indexOf('ROLE_MENTEE') !='-1')) {
          return true;
      }
      else {
          return false;
      }
    },
    isMenteeNotificationSettings() {
      var loggedinUserRoles = store.state.roles;
      if((loggedinUserRoles.indexOf('ROLE_MENTEE') != '-1') || (loggedinUserRoles.indexOf('ROLE_STUDENT') !='-1')) {
          if(this.userGroupRole == 'ROLE_MENTEE') {
            return true;
          }
          else {
            return false;
          }
      }
      else {
          return false;
      }
    },
    isMenteeUserProfile() {
      var userRoles = this.roles;
      if((userRoles.indexOf('ROLE_MENTEE') != '-1') || (userRoles.indexOf('ROLE_STUDENT') !='-1')) {
          if(this.userGroupRole == 'ROLE_MENTEE') {
            return true;
          }
          else {
            return false;
          }
      }
      else {
          return false;
      }
    },
    displayNotificationSetting: function() {
      if(this.sms_flag === true) {
        this.notification_phone = true;
      }
      else {
        this.notification_phone = false;
      }
    },
    updateMenteesNotifications () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        axios('/mentees-notification-update',
          {
            method: 'POST',
            data: {
                "email_flag": this.email_flag,
                "sms_flag": this.sms_flag,
                "phone_no": this.phone_number,
                "frequency": this.frequency_value,
                },
          }
        )
       .then((resp) => {
          this.flash({ message: resp.data, variant: 'success' });
          this.navigate("/myprofile");
        })
       .catch(error => {

       });
      }).catch(() => {
        // catches the error;
      });
    },

    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        this.pwd_update();
      }).catch(() => {
        // catches the error;
      });
    },
    onUpdate () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        this.update();
      }).catch(() => {
        // catches the error;
      });
    },
    pwd_update: function() {
      axios('/password-update',
        {
          method: 'PATCH',
          data: {password: this.password},
        }
      )
     .then((resp) => {
       this.$store.dispatch('logout');
       this.flash({ message: 'Your password is changed. Please login.', variant: 'success' });
       this.navigate("/login");
      })
     .catch(error => {

     });
    },
    update: function () {
      if(this.$route.params.user_id) {
        this.update_url = '/user-profile/' + this.$route.params.user_id;
      }
      else {
        this.update_url = '/my-profile';
      }
      var userAccountId = '';
      if(store.state.user_accountid) {
        userAccountId = store.state.user_accountid;
      }
       axios(this.update_url,
         {
           method: 'PATCH',
           data:  {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    phone_number: this.phone_number,
                    roles: this.roles,
                    userGroups: this.groups,
                    accountId: userAccountId,
                  },
         }
       )
      .then((resp) => {
        this.flash({ message: "User's profile is updated.", variant: 'success' });
        this.navigate("/profile/" + this.$route.params.user_id);
       })
      .catch(error => {
          const fieldErrors =  [{}];
            var errMsgObj = error.response.data.message;

            Object.keys(errMsgObj).map(key => {
               var newFieldErr = {field:key, msg:errMsgObj[key]};
               fieldErrors.push(newFieldErr);
            });
            this.$validator.errors.add(fieldErrors);
      });
    },
    setprofile_mode(viewmode) {
      this.action = viewmode
    },
    goBack() {
      this.$router.go(-1)
    },
    navigate(pathUrl) {
      router.go({
        path: pathUrl,
        force: true
      });
    },
    isInArray(value, array) {
      return array.indexOf(value) > -1;
    },
    updateMenteesTasklist () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        axios('/mentees-tasklist-update/' + this.$route.params.user_id,
          {
            method: 'POST',
            data: {"tasklists_assigned": this.taskListsAssigned},
          }
        )
       .then((resp) => {
          this.flash({ message: resp.data.successMsg, variant: 'success' });
          this.navigate("/profile/" + this.$route.params.user_id);
        })
       .catch(error => {

       });
      }).catch(() => {
        // catches the error;
      });
    },
    checkUserMultipleGroupPermission() {
      var loggedinUserRoles = store.state.roles;
      if((this.roles.indexOf('ROLE_MENTEE') !='-1' ||
        this.roles.indexOf('ROLE_INSTRUCTOR') !='-1' ||
        this.roles.indexOf('ROLE_STUDENT') !='-1' ) &&
        ((loggedinUserRoles.indexOf('ROLE_MENTEE') === -1) &&
        (loggedinUserRoles.indexOf('ROLE_STUDENT') === -1))) {
          return true;
      }
      else {
          return false;
      }
    },
    rolesFormatter(value) {
        let formattedRoles = value.replace(new RegExp('ROLE_', 'g'),'');
        formattedRoles =  formattedRoles.replace(new RegExp('_', 'g'),' ');
        return formattedRoles.toLowerCase();
    },
  },
  created: function() {
    var roles = this.$store.state.roles;
    if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
      this.masterAdmin = true;
    }
    if(
      ((roles.indexOf('ROLE_ADMIN') > -1)
      ||
      (this.$store.state.switch_admin_username))
      &&
      ((this.$store.state.switch_flag != 'Instructor')
      &&
      (this.$store.state.switch_flag != 'Mentor'))
      ) {
      this.admin = true;
    }

    if(
      ((roles.indexOf('ROLE_MENTOR') > -1)
      ||
      (roles.indexOf('ROLE_MENTEE') > -1)
      ||
      (roles.indexOf('ROLE_INSTRUCTOR') > -1)
      ||
      (roles.indexOf('ROLE_STUDENT') > -1))
      &&
      ((this.$store.state.switch_flag != 'Manager')
      &&
      (this.$store.state.switch_flag != 'Primary Admin'))
      ) {
      this.showBackButton = true;
    }
    this.loading = true;
    document.body.className = 'profile-page';
    if(this.$route.params.user_id) {
      this.get_url = '/user-profile/' + this.$route.params.user_id;
      this.pageName = 'User Profile';
    }
    else {
      this.get_url = '/my-profile';
      this.pageName = 'My Profile';
    }
    var userAccountId = '';
    if(store.state.user_accountid) {
      userAccountId = store.state.user_accountid;
    }
    axios(this.get_url,
      {
        method: 'POST',
        data: {
               "accountId": userAccountId,
        }
      }
    )
    .then(resp => {
      this.loading = false;
      for(var i=0; i < resp.data.user.groups.length; i++) {
        this.groups.push(resp.data.user.groups[i].id);
        this.group_names.push(resp.data.user.groups[i].name);
      }
      this.first_name = resp.data.user.first_name;
      this.last_name = resp.data.user.last_name;
      this.phone_number = resp.data.user.phone_number;
      this.email = resp.data.user.email;
      this.roles = resp.data.user.roles;
      this.role_options = resp.data.roleoptions;
      this.groups_options = resp.data.groupsoptions;
      this.admin_flag = resp.data.adminflag;
      this.is_mentee = resp.data.user.is_mentee;
      if(this.isMenteeProfile())
      {
          for(var j=0; j < resp.data.user.taskLists.length; j++) {
            this.taskListsAssigned.push(resp.data.user.taskLists[j].id);
            this.taskListsNames.push(resp.data.user.taskLists[j].name);
          }
          this.userGroupRole = resp.data.user.userGroupRole;
          this.email_flag = resp.data.user.emailFlag;
          if(this.email_flag === true) {
            this.email_display_flag = 'Yes';
          }
          else {
            this.email_display_flag = 'No';
          }
          this.sms_flag = resp.data.user.smsFlag;
          if(this.sms_flag === true) {
            this.notification_phone = true;
            this.sms_display_flag = 'Yes';
          }
          else {
            this.sms_display_flag = 'No';
          }
          this.frequency_value = resp.data.user.frequency;
      }
      this.showGroupEdit = this.checkUserMultipleGroupPermission();
    })
    .catch(error => {
      this.loading = false;
    })
  },
  mounted() {
    var loggedinUserRoles = store.state.roles;
    if(loggedinUserRoles.indexOf('ROLE_ADMIN') !='-1'
        || (loggedinUserRoles.indexOf('ROLE_ADMIN') !='-1'
            && loggedinUserRoles.indexOf('ROLE_MENTOR') !='-1') || (store.state.switch_admin_username)) {
      axios('/alltasklists-account',
        {
          method: 'GET',
          params: {
            account_id: this.$store.state.user_accountid,
          }
        },
      )
      .then(response => {
            this.editTaskLists = response.data;

       })
      .catch(error => {

      });
    }
  },
}
</script>

<style scoped>
.comment-heading {
  padding: 12px 5px 12px 5px;
  font-size: 18px;
  color: #FFF;
  margin-top: 0px;
}
.comment-wrapper {
  padding: 5px;
  background-color: #FFF;
  width: 90%;
  min-height: 100px;
}
.task-title {
  margin: 0px 5px 5px 5px;
  border-bottom: 1px solid #DDD;
}
.task-score {
  font-weight: bold;
}
.comment-text {
  margin-top: 5px;
}
.tip:before {
  position: absolute;
  top: -14px;
  left: 98px;
  display: inline-block;
  border-right: 14px solid transparent;
  border-bottom: 14px solid #fff;
  border-left: 14px solid transparent;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  content: '';
}

.tip:after {
  position: absolute;
  top: -12px;
  left: 99px;
  display: inline-block;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #fff;
  border-left: 12px solid transparent;
  content: '';
}

.tip.left:before {
  border-top: 14px solid transparent;
  border-right: 14px solid #fff;
  border-bottom: 14px solid transparent;
  border-right-color: rgba(169, 169, 169, 1);
  left: -28px;
  top: 20px;
}

.tip.left:after {
  border-top: 12px solid transparent;
  border-right: 12px solid #fff;
  border-bottom: 12px solid transparent;
  left: -24px;
  top: 22px;
}
.tip-left {
  top: 10px;
  left: -25px;
  border-top-color: transparent;
  border-left-color: transparent;
  border-bottom-color: transparent;
}
.tip {
		background: #FFF;
		border: 2px solid #ccc;
		padding: 10px;
		position: relative;
	}
.dialogbox .body {
  position: relative;
  max-width: 300px;
  height: auto;
  margin: 20px 10px;
  padding: 5px;
  border-radius: 3px;
  border: 5px solid #ccc;
}

.body .message {
  min-height: 30px;
  border-radius: 3px;
  font-family: Arial;
  font-size: 14px;
  line-height: 1.5;
  color: #797979;
}
    .slide-leave-active,
    .slide-enter-active {
      transition: 0.4s;
    }
    .slide-enter {
      transform: translate(100%, 0);
    }
    .slide-leave-to {
      transform: translate(-100%, 0);
    }
.profile-page .main-wrapper {
   background-color: #FFF;
   padding: 10px;
   min-height: 400px;
   transform: none;
   margin-top:20px;
   width: 50%;
}
@media(max-width:768px) {
  .profile-page .main-wrapper {
     width: 70%;
   }
}
@media (max-width: 560px) {
 .profile-page .main-wrapper {
    border-radius: 5px;
    width: 100%;
  }
}
@media (max-width: 575.98px) {
  .col-xs-1 {
   width: 8.33333333%;
  }
  .col-xs-11 {
    width: 91.66666667%;
  }
  .col-xs-4 {
    width: 33.333333%;
  }
  .col-xs-8 {
    width: 66.666667%;
  }
  .col-xs-9 {
    width: 75%;
  }
  .col-xs-3 {
    width: 25%;
  }
}
.content-main-wrapper h3 {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  color: #555;
}
.marginbot10 {
  margin-bottom: 10px;
}
.profile-heading {
  margin-top: 10px;
}
label {
  font-size: 12px;
}
.profile-sec-sep {
  border-top: 1px solid #DDD;
  margin: 20px 0px 20px 0px;
}
.row {
  margin-left: 0px;
  margin-right: 0px;
}
#profile-link-wrapper .profile-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}
#edit-profile-wrapper label {
  padding-left: 0px;
}
.edit-profile-wrapper .submit{
  padding-right: 15px;
  margin-top: 10px;
}
.custom-chkbox {
  width: 10%;
  float: left;
}
label.group-chkbox {
  font-weight: normal;
}
.roles { text-transform: capitalize; }
.profile-container label{
  font-weight:bold;
}
.profile-container .chkboxwrapper label{
  font-weight:normal;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 23px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.notification-wrapper .label-bold {
  padding-top: 3px;
  font-size: 12px;
  font-weight: bold !important;
}
.create_tasks_status label {
  font-weight: normal;
  font-size: 14px;
}
.edit-profile-wrapper {
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/user_profile.vue